import styled from 'styled-components';

import { brandFont } from 'styles/brand-font';
// This is a temporary fix to achieve https://rbictg.atlassian.net/browse/IREQ-3564
// The RBI platform should NOT be responsible for calculating prices/taxes, this should be done on the POS level

export const PriceWithoutTaxStyle = styled.div`
  text-transform: none;
  font: ${brandFont.copyTwo};
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 16px;
  color: '#502314';
`;
